"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefiPassportStorageFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var DefiPassportStorageFactory = /** @class */ (function (_super) {
    __extends(DefiPassportStorageFactory, _super);
    function DefiPassportStorageFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    DefiPassportStorageFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    DefiPassportStorageFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    DefiPassportStorageFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    DefiPassportStorageFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    DefiPassportStorageFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return DefiPassportStorageFactory;
}(contracts_1.ContractFactory));
exports.DefiPassportStorageFactory = DefiPassportStorageFactory;
var _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "approvedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultActiveSkin",
        outputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "skin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "skinTokenId",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "defaultSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "skinManager",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "whitelistedSkins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506101f0806100206000396000f3fe608060405234801561001057600080fd5b50600436106100575760003560e01c80638e3d56151461005c57806397c0c9dd14610094578063d7127150146100b7578063e838c334146100e5578063ee007d2b14610110575b600080fd5b61007f61006a366004610170565b60036020526000908152604090205460ff1681565b60405190151581526020015b60405180910390f35b61007f6100a2366004610170565b60056020526000908152604090205460ff1681565b61007f6100c5366004610191565b600460209081526000928352604080842090915290825290205460ff1681565b6009546100f8906001600160a01b031681565b6040516001600160a01b03909116815260200161008b565b60065460075460085461012e926001600160a01b0390811692169083565b604080516001600160a01b0394851681529390921660208401529082015260600161008b565b80356001600160a01b038116811461016b57600080fd5b919050565b600060208284031215610181578081fd5b61018a82610154565b9392505050565b600080604083850312156101a3578081fd5b6101ac83610154565b94602093909301359350505056fea264697066735822122060c83a695bd2425851c71d7e193767d656b69a0888db0afad45e04c7700f747c64736f6c63430008040033";
